import _ from 'lodash';

class MultiMonitorService {
    static uniqueIdPrefix = 'multi-monitor';

    static windowFeatures = 'width=1200,height=700,top=150';

    static childLimit = 5;

    static intervalTimeout = 3000;

    static hrefTag = 'multi_type';

    static hrefTagChild = 'child';

    static hrefTagParent = 'parent';

    static inactiveCacheKey = 'MULTI_MONITOR_INACTIVE_CACHE_KEY';

    static childrenHistoryCacheKey = 'MULTI_MONITOR_CHILDREN_HISTORY_CACHE_KEY';

    static staticPath = '/patent-view';

    static createUUID() {
        const s = [];
        const hexDigits = '0123456789abcdef';
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        // bits 12-15 of the time_hi_and_version field to 0010
        s[14] = '4';
        // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = '-';
        return s.join('');
    }

    constructor() {
        this.isChild = false;
        this.isParentActive = false;
        this.limit = MultiMonitorService.childLimit;
        this.childrenList = [];
        this.checkChildrenStatusInterval = null;
        this.checkParentStatusInterval = null;
        this.$router = null;
        this.isInited = false;
        this.activeId = null;
    }

    // 初始化一些必要参数
    init($router, cb) {
        if (this.isInited) return;
        this.isInited = true;
        this.$router = $router;
        // 刷新后需要清除url上的无用参数
        this.clearUrlMark();
        this.isChild = this.child__checkParentIsAlive() && !this.child__getIsInactive();
        if (this.isChild) {
            this.child__addUrlMark();
            this.child__setToggleCallback(cb);
            this.child__setCheckStatusInterval();
            this.child__addBeforeunloadCallback();
        }
    }

    // 打开子窗口
    parent__openNewWindow(path, queryString) {
        if (this.childrenList.length >= MultiMonitorService.childLimit || this.isChild) return;
        this.isParentActive = true;
        this.parent__addBeforeunloadCallback();
        this.parent__addUrlMark();
        const historyCache = this.parent__getChildrenListCache();
        if (!this.childrenList.length && historyCache.length) {
            // 初始化打开, 需要从缓存中获取历史打开的窗口
            _.forEach(historyCache, historyPath => {
                this.parent__openNewWindowByPath(historyPath, queryString);
            });
        } else {
            this.parent__openNewWindowByPath(path, queryString);
        }
        this.parent__setCheckStatusInterval();
    }

    // 生成子窗口
    parent__openNewWindowByPath(path, queryString) {
        const windowId = `${MultiMonitorService.uniqueIdPrefix}_${MultiMonitorService.createUUID()}`;
        const parentTag = `${MultiMonitorService.hrefTag}=${MultiMonitorService.hrefTagChild}`;
        const fullUrl = `${MultiMonitorService.staticPath}${path}?${queryString}&${parentTag}`;
        const child = window.open(fullUrl, windowId, MultiMonitorService.windowFeatures);
        this.childrenList.push({ key: windowId, value: child });
    }

    // 设置父窗口轮询
    parent__setCheckStatusInterval() {
        if (this.checkChildrenStatusInterval) return;
        this.checkChildrenStatusInterval = setInterval(() => {
            let isAllClosed = _.get(this.childrenList, child => !this.parent__checkChildIsAlive(child));
            if (isAllClosed) {
                this.parent__clearCheckStatusInterval();
                this.parent__clearChildrenList();
                this.clearUrlMark();
                this.parent__removeBeforeunloadCallback();
                this.isParentActive = false;
                this.activeId = null;
            } else {
                this.parent__updateAliveChildrenList();
            }
        }, MultiMonitorService.intervalTimeout);
    }

    // 设置子窗口轮询
    child__setCheckStatusInterval() {
        if (this.checkParentStatusInterval) return;
        this.checkParentStatusInterval = setInterval(() => {
            const isParentIsAlive = this.child__checkParentIsAlive();
            if (!isParentIsAlive) {
                this.child__removeBeforeunloadCallback();
                this.child__clearCheckStatusInterval();
                this.isChild = false;
                window.close();
            }
        }, MultiMonitorService.intervalTimeout);
    }

    // 清除父窗口轮询
    parent__clearCheckStatusInterval() {
        if (this.checkChildrenStatusInterval) {
            clearInterval(this.checkChildrenStatusInterval);
            this.checkChildrenStatusInterval = null;
        }
    }

    // 清除子窗口轮询
    child__clearCheckStatusInterval() {
        if (this.checkParentStatusInterval) {
            clearInterval(this.checkParentStatusInterval);
            this.checkParentStatusInterval = null;
        }
    }

    // 判断父窗口是否存在
    child__checkParentIsAlive() {
        try {
            // if (window.opener === window) return false;
            const parentHref = _.get(window, 'opener.location.href', '');
            const parentMatchTag = `${MultiMonitorService.hrefTag}=${MultiMonitorService.hrefTagParent}`;
            return parentHref.includes(parentMatchTag);
        } catch (e) {
            return false;
        }
    }

    // 判断子窗口是否存在
    parent__checkChildIsAlive(child) {
        try {
            const childHref = _.get(child, 'value.location.href', '');
            const childMatchTag = `${MultiMonitorService.hrefTag}=${MultiMonitorService.hrefTagChild}`;
            return ((childHref === 'about:blank') || childHref.includes(childMatchTag)) && !child.value.closed;
        } catch (e) {
            return false;
        }
    }

    // 清除并更新已经关闭的子窗口
    parent__updateAliveChildrenList() {
        this.childrenList = this.childrenList.filter(item => this.parent__checkChildIsAlive(item));
        this.parent__setChildrenListCache(this.childrenList);
    }

    // 清除所有子窗口
    parent__clearChildrenList() {
        this.childrenList = [];
    }

    // 设置子窗口缓存 (全量更新)
    parent__setChildrenListCache(list) {
        const cache = list.map(item => {
            return _.get(item, 'value.location.pathname', '').replace(MultiMonitorService.staticPath, '');
        });
        localStorage.setItem(MultiMonitorService.childrenHistoryCacheKey, JSON.stringify(cache));
    }

    // 获取子窗口缓存
    parent__getChildrenListCache() {
        const cache = JSON.parse(localStorage.getItem(MultiMonitorService.childrenHistoryCacheKey) || '[]');
        return cache.slice(0, MultiMonitorService.childLimit);
    }

    // 设置子窗口切换使用的回调
    child__setToggleCallback(cb) {
        window.MultiMonitorChildToggleCallback = cb;
        window.MultiMonitorChildClose = () => this.child__exit();
    }

    // 触发子窗口回调
    parent__triggerChildToggleCallback(patentId) {
        if (!this.isInited) throw new Error('Please Call Init At First');
        this.activeId = patentId;
        _.forEach(this.childrenList, child => {
            child.value && child.value.MultiMonitorChildToggleCallback && child.value.MultiMonitorChildToggleCallback(patentId);
        });
    }

    // 在父窗口退出联动模式
    parent__exit() {
        this.isParentActive = false;
        this.activeId = null;
        this.parent__removeBeforeunloadCallback();
        _.forEach(this.childrenList, child => {
            child.value.MultiMonitorChildClose && child.value.MultiMonitorChildClose();
        });
        this.parent__clearChildrenList();
    }

    // 在子窗口退出联动模式
    child__exit() {
        this.child__removeBeforeunloadCallback();
        window.close();
    }

    // 从$router获取参数
    getParamsFromRouter() {
        return {
            name: _.get(this.$router, 'currentRoute.name'),
            path: _.get(this.$router, 'currentRoute.path'),
            params: _.get(this.$router, 'currentRoute.params', {}),
            query: _.get(this.$router, 'currentRoute.query', {}),
        };
    }

    // 更新父窗口在url中的标识
    parent__addUrlMark() {
        if (!this.isInited) throw new Error('Please Call Init At First');
        const { name, path, params, query } = this.getParamsFromRouter();
        this.$router.push({ name, path, params: { ...params }, query: { ...query, [MultiMonitorService.hrefTag]: MultiMonitorService.hrefTagParent } });
    }

    // 更新子窗口在url中的标识
    child__addUrlMark() {
        if (!this.isInited) throw new Error('Please Call Init At First');
        const { name, path, params, query } = this.getParamsFromRouter();
        this.$router.push({ name, path, params: { ...params }, query: { ...query, [MultiMonitorService.hrefTag]: MultiMonitorService.hrefTagChild } });
    }

    // 清除当前窗口在url中的标识
    clearUrlMark() {
        if (!this.isInited) throw new Error('Please Call Init At First');
        const { name, path, params, query } = this.getParamsFromRouter();
        this.$router.push({ name, path, params: { ...params }, query: { ...query, [MultiMonitorService.hrefTag]: undefined } });
    }

    // 判断是否包含子窗口的标识
    child__hasUrlMark() {
        if (!this.isInited) throw new Error('Please Call Init At First');
        return _.get(this.$router, `currentRoute.query.${MultiMonitorService.hrefTag}`, '') === MultiMonitorService.hrefTagChild;
    }

    parent__addBeforeunloadCallback() {
        this.parent__removeBeforeunloadCallback();
        window.addEventListener('beforeunload', this.parent__beforeunloadCallback);
    }

    parent__removeBeforeunloadCallback() {
        window.removeEventListener('beforeunload', this.parent__beforeunloadCallback);
    }

    parent__beforeunloadCallback(e) {
        (e || window.event).returnValue = true;
        return true;
    }

    child__addBeforeunloadCallback() {
        this.child__removeBeforeunloadCallback();
        window.addEventListener('beforeunload', this.child__beforeunloadCallback);
    }

    child__removeBeforeunloadCallback() {
        window.removeEventListener('beforeunload', this.child__beforeunloadCallback);
    }

    child__beforeunloadCallback(e) {
        const cache = JSON.parse(sessionStorage.getItem(MultiMonitorService.inactiveCacheKey) || '[]');
        const matchIndex = _.findIndex(cache, name => window.name === name);
        if (matchIndex === -1) {
            cache.push(window.name);
            sessionStorage.setItem(MultiMonitorService.inactiveCacheKey, JSON.stringify(cache));
        }
        (e || window.event).returnValue = true;
        return true;
    }

    child__getIsInactive() {
        const cache = JSON.parse(sessionStorage.getItem(MultiMonitorService.inactiveCacheKey) || '[]');
        const matchIndex = _.findIndex(cache, name => window.name === name);
        return matchIndex !== -1;
    }
}

export default new MultiMonitorService();
